import { render, staticRenderFns } from "./CustomDisplayElementConfig.vue?vue&type=template&id=dd938c62&scoped=true&lang=html"
import script from "./CustomDisplayElementConfig.vue?vue&type=script&lang=js"
export * from "./CustomDisplayElementConfig.vue?vue&type=script&lang=js"
import style0 from "./CustomDisplayElementConfig.vue?vue&type=style&index=0&id=dd938c62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd938c62",
  null
  
)

export default component.exports